import { Handle, type NodeProps } from "@xyflow/react";
import type { FunctionNodeData } from "@/types/decision-graph";
import { getHandlePositions } from "../utils/handle-positions";

export function FunctionNode({ data }: NodeProps) {
  const d = data as FunctionNodeData;
  const { inputPosition, outputPosition } = getHandlePositions(d.layoutDirection);

  return (
    <div className="rounded-md border border-slate-300 bg-slate-50 px-3 py-2 text-xs shadow-sm min-w-[90px]">
      <Handle type="target" position={inputPosition} id="input" />
      <div className="font-medium text-slate-700 text-[10px] mb-0.5">
        {(d.functionName || d.label || "FN").toUpperCase()}
      </div>
      <div className="text-slate-900 font-mono text-center">
        {d.label}
      </div>
      <Handle type="source" position={outputPosition} id="result" />
    </div>
  );
}
